<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-12 21:42 -->
<!-- Description:  -->
<template>
  <div>
    <PermissionForm @saved="afterSave()"></PermissionForm>
  </div>
</template>
<script>
import AdminService from "../AdminService.js";
import PermissionForm from "./PermissionForm.vue";

// script content
export default {
  name: "PermissionFormView",
  components: {
    PermissionForm,
  },

  // directives

  props: {
    id: {}
  },

  data: () => ({
    reg: {}
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    afterSave() {
      this.$router.push({
        name: "admin.permission-list",
      })
    }
    //
    //
  }
};
</script>
<style scoped></style>

